var swatchHighlight = () => {

    var swatchHigh = (selectedItem) => {
        selectedItem.attr("class", 'swatches-highlight ' + selectedItem.attr("class"));
    };
    var addRemoveSwatchHighlight = setInterval(function() {
        if ($(".result-list").length > 0 && $(".product-img").length > 0) {
            $('.product-tile').each(function() {
                if ($(this).find('.product-img').length > 0 && $(this).find('.product-img').data('originalalternates')) {
                    var originalalternates = $(this).find('.product-img').data('originalalternates').split('|')[0];
                    var foundSwatch = false;
                    $(this).find('.swatches li a').each(function() {
                        var swatchalternates = $(this).data('swatchalternates').split('|')[0],
                            dataAlternatesEqual = originalalternates === swatchalternates,
                            ex1 = !foundSwatch,
                            ex2 = window.location.href.indexOf('facet=dil_pricereduced') > -1,
                            ex3 = !(window.location.href.indexOf('beauty') > -1),
                            ex4 = ex1 || ex2 || ex3,
                            ex5 = dataAlternatesEqual && ex4;
                        if (ex5) {
                          swatchHigh($(this));
                          clearInterval(addRemoveSwatchHighlight);
                        }
                        foundSwatch = true;
                    });
                }
            });

            $('.swatches a').on('click', function() {
                if ($(this).hasClass('swatches-highlight')) return false;
                var thisProductSwatches = $(this).parents('.swatches').find('a');
                $.each(thisProductSwatches, function() {
                    if ($(this).hasClass('swatches-highlight')) $(this).removeClass('swatches-highlight');
                });
                swatchHigh($(this));
            });
        }
    }, 1000);
};

export {
    swatchHighlight
}
